import { makeStyles, Theme } from '@material-ui/core'

const buildStyles = makeStyles((theme: Theme) => ({
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },
  container: {
    padding: '20px',
    opacity: 0,
    animation: '$fadeIn 0.5s',
    'animation-fill-mode': 'forwards',
  },
  amountBlock: {
    display: 'flex',
    justifyContent: 'center',
    padding: '10px',
  },
  voucherConditionLabel: {
    marginTop: '50px',
    fontSize: '16px',
  },
  star: {
    width: '15px',
    height: '15px',
    marginRight: '15px',
    minWidth: '15px',
    minHeight: '15px',
  },
}))

export default buildStyles
